// @ts-nocheck
import { Component } from '@theme/component';
import { getStoreDetailEndpoint, buildFieldMask, getStoreHoursStatus } from './store-locator-helpers.js';

/**
 * Store Hours Component
 * Fetches and displays current open/closed status for a specific location
 */
class StoreHours extends Component {
  /** @type {AbortController|null} */
  #abortController = null;

  async connectedCallback() {
    // Clear any initial content
    this.innerHTML = '';

    const storeId = this.dataset.storeId;
    const apiKey = this.dataset.apiKey;

    if (!storeId || !apiKey) {
      return;
    }

    await this.#fetchAndRender(apiKey, storeId);
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  /**
   * Fetch store data and render hours
   * @param {string} apiKey - Uberall store finder key
   * @param {string} storeId - Store location ID
   */
  async #fetchAndRender(apiKey, storeId) {
    this.#abortController = new AbortController();

    try {
      const endpoint = getStoreDetailEndpoint(apiKey, storeId);
      const fieldMask = buildFieldMask(['openingHours', 'openNow', 'nextOpen', 'futureOpeningDate', 'name']);

      const response = await fetch(`${endpoint}${fieldMask}`, {
        signal: this.#abortController.signal,
      });

      if (!response.ok) {
        return;
      }

      const data = await response.json();
      // API returns data directly in response, not under response.location
      const store = data.response;

      if (!store || !store.openingHours) {
        return;
      }

      this.#render(store);
    } catch {
      // Silently fail - show nothing on error
      return;
    }
  }

  /**
   * Render the store status
   * @param {Object} store - Store data from API
   */
  #render(store) {
    const translations = {
      open_now: 'Open Now',
      open_until: 'Open until {{ time }}',
      opens_at: 'Opens at {{ time }}',
      closed: 'Closed',
      temporarily_closed: 'Temporarily Closed',
      coming_soon: 'Opening {{ date }}',
    };

    const status = getStoreHoursStatus(store, translations);

    this.innerHTML = `
      <div class="store-hours__status ${status.isOpen ? 'is-open' : ''}">
        <span class="store-hours__status-dot"></span>
        <span class="store-hours__status-text">${status.text}</span>
      </div>
    `;
  }
}

if (!customElements.get('store-hours')) {
  customElements.define('store-hours', StoreHours);
}

export default StoreHours;
